import { initEmojiLib } from '../lib/emoji.lib.js'

initEmojiLib()

export const EmojiLoader = () => null
